import { css } from "@/utils/css";
import { __ } from "@wordpress/i18n";

type Props = React.PropsWithChildren<{
    htmlFor?: string;
    label?: string;
    help?: string | React.ReactNode;
    className?: string;
}>;

export function FormBox({ htmlFor, label, help, children, className }: Props) {
    return (
        <label htmlFor={htmlFor} className={css(className || "")}>
            <span className={css("form-label")}>{label}</span>
            {children}
            {help && <p className={css("form-help")}>{help}</p>}
        </label>
    );
}
